// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Config from "../../Config.bs.js";
import * as CountryContext from "../data-source/country-config/context/CountryContext.bs.js";
import * as CrmAssetsManager from "../../root/crm/to-be-migrated/assets/CrmAssetsManager.bs.js";

var porterLogo = CrmAssetsManager.getImage("porter-logo.png");

var userProfile = CrmAssetsManager.getImage("user_profile.svg");

var bdFlag = CrmAssetsManager.getImage("bd.svg");

var uaeFlag = CrmAssetsManager.getImage("uae.svg");

var trFlag = CrmAssetsManager.getImage("tr.svg");

function getPorterLogoHref(param) {
  return Config.Env.getHostName(undefined) + "/administrators/login_home";
}

function HeaderComponent(Props) {
  var match = CountryContext.useContext(undefined);
  var tmp;
  switch (match.country.TAG | 0) {
    case /* UAE */0 :
        tmp = React.createElement("div", {
              className: "selected-country"
            }, React.createElement("img", {
                  className: "porter-logo",
                  alt: "",
                  src: uaeFlag
                }), "UAE");
        break;
    case /* India */1 :
        tmp = null;
        break;
    case /* BD */2 :
        tmp = React.createElement("div", {
              className: "selected-country"
            }, React.createElement("img", {
                  className: "porter-logo",
                  alt: "",
                  src: bdFlag
                }), "Bangladesh");
        break;
    case /* TR */3 :
        tmp = React.createElement("div", {
              className: "selected-country"
            }, React.createElement("img", {
                  className: "porter-logo",
                  alt: "",
                  src: trFlag
                }), "Turkey");
        break;
    case /* MY */4 :
        tmp = React.createElement("div", {
              className: "selected-country"
            }, "Malaysia");
        break;
    
  }
  return React.createElement("div", {
              className: "app-header-container"
            }, React.createElement("div", {
                  className: "header-container__porter-logo"
                }, React.createElement("a", {
                      href: getPorterLogoHref(undefined)
                    }, React.createElement("img", {
                          className: "porter-logo",
                          alt: "https://porter.in/",
                          src: porterLogo
                        }))), tmp);
}

var make = HeaderComponent;

export {
  porterLogo ,
  userProfile ,
  bdFlag ,
  uaeFlag ,
  trFlag ,
  getPorterLogoHref ,
  make ,
  
}
/* porterLogo Not a pure module */
